// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import { baseIcon, defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
import { isWaffle, isWhiteLabel } from '@bubble-ui/particle-design-versions';
var IconInformationPathPancake = 'M0 10C0 4.486 4.486 0 10 0s10 4.486 10 10-4.486 10-10 10S0 15.514 0 10Zm2 0c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8Zm9.5-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM11 9v5H9V9h2Z';
var IconInformationPathWaffle = 'M9.167 9.167h1.666v5H9.167v-5ZM10 5a1.25 1.25 0 1 0 0 2.5A1.25 1.25 0 0 0 10 5Zm9.167 5c0 5.055-4.113 9.167-9.167 9.167C4.945 19.167.833 15.055.833 10 .833 4.946 4.945.833 10 .833S19.167 4.946 19.167 10ZM17.5 10c0-4.136-3.365-7.5-7.5-7.5S2.5 5.864 2.5 10s3.365 7.5 7.5 7.5 7.5-3.364 7.5-7.5Z';
var IconInformationPathWaffleFilled = 'M10 .833C4.942.833.833 4.942.833 10S4.942 19.167 10 19.167s9.167-4.109 9.167-9.167S15.058.833 10 .833Zm.833 13.334H9.167v-5h1.666v5ZM10 7.5c-.692 0-1.25-.558-1.25-1.25S9.308 5 10 5s1.25.558 1.25 1.25S10.692 7.5 10 7.5Z';
var IconInformationPathWhiteLabel = 'M9.175 14.075h1.65V9h-1.65v5.075Zm.82-6.475c.24 0 .442-.081.607-.243a.81.81 0 0 0 .248-.603.833.833 0 0 0-.243-.606.811.811 0 0 0-.603-.248.833.833 0 0 0-.606.243.81.81 0 0 0-.248.603c0 .239.081.441.243.606a.81.81 0 0 0 .603.248Zm.01 10.57a7.984 7.984 0 0 1-3.179-.639 8.231 8.231 0 0 1-2.604-1.753 8.233 8.233 0 0 1-1.753-2.603A7.992 7.992 0 0 1 1.83 9.99c0-1.13.212-2.19.638-3.174a8.234 8.234 0 0 1 4.357-4.347 7.992 7.992 0 0 1 3.184-.638c1.13 0 2.189.212 3.174.637A8.248 8.248 0 0 1 17.53 6.82c.426.989.638 2.047.638 3.174a7.986 7.986 0 0 1-.637 3.18 8.23 8.23 0 0 1-1.754 2.604 8.25 8.25 0 0 1-2.598 1.753 7.943 7.943 0 0 1-3.174.638ZM10 16.44c1.792 0 3.314-.625 4.564-1.876 1.25-1.25 1.876-2.772 1.876-4.564 0-1.792-.625-3.314-1.876-4.564C13.314 4.185 11.792 3.56 10 3.56c-1.792 0-3.314.625-4.564 1.876C4.186 6.686 3.56 8.208 3.56 10c0 1.792.625 3.314 1.876 4.564 1.25 1.25 2.772 1.876 4.564 1.876Z';
var IconInformationPathWhiteLabelFilled = 'M9.175 14.075h1.65V9h-1.65v5.075Zm.82-6.475c.24 0 .442-.081.607-.243a.81.81 0 0 0 .248-.603.833.833 0 0 0-.243-.606.811.811 0 0 0-.603-.248.833.833 0 0 0-.606.243.81.81 0 0 0-.248.603c0 .239.081.441.243.606a.81.81 0 0 0 .603.248Zm.01 10.57a7.984 7.984 0 0 1-3.179-.639 8.231 8.231 0 0 1-2.604-1.753 8.233 8.233 0 0 1-1.753-2.603A7.992 7.992 0 0 1 1.83 9.99c0-1.13.212-2.19.638-3.174a8.234 8.234 0 0 1 4.357-4.347 7.992 7.992 0 0 1 3.184-.638c1.13 0 2.189.212 3.174.637A8.248 8.248 0 0 1 17.53 6.82c.426.989.638 2.047.638 3.174a7.986 7.986 0 0 1-.637 3.18 8.23 8.23 0 0 1-1.754 2.604 8.25 8.25 0 0 1-2.598 1.753 7.943 7.943 0 0 1-3.174.638Z';
var IconInformationViewBoxWaffle = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconInformationViewBoxWaffleFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconInformationViewBoxWhiteLabel = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconInformationViewBoxWhiteLabelFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
export var IconInformation = baseIcon('IconInformation', {
  groupProps: defaultIconGroupProps,
  getPath: _ref => {
    var {
      designVersion,
      filled
    } = _ref;
    return isWhiteLabel(designVersion) ? filled ? IconInformationPathWhiteLabelFilled : IconInformationPathWhiteLabel : isWaffle(designVersion) ? filled ? IconInformationPathWaffleFilled : IconInformationPathWaffle : IconInformationPathPancake;
  },
  shapeSize: _ref2 => {
    var {
      designVersion,
      filled
    } = _ref2;
    return isWhiteLabel(designVersion) ? filled ? IconInformationViewBoxWhiteLabelFilled : IconInformationViewBoxWhiteLabel : isWaffle(designVersion) ? filled ? IconInformationViewBoxWaffleFilled : IconInformationViewBoxWaffle : {};
  }
});
//# sourceMappingURL=index.js.map